import type {PartGridRowModel} from "../CategorizationTableDataModel.ts";
import type {GridFilterOperator} from '@mui/x-data-grid';
import {ScoreBetweenFilterComponent} from "./ScoreBetweenFilterComponent.tsx";

export const scoreBetweenFilter: GridFilterOperator<PartGridRowModel, number> =
    {
        headerLabel: 'Score Between',
        label: 'Between',
        value: 'between',
        getApplyFilterFn: (filterItem) => {
            if (!Array.isArray(filterItem.value) || filterItem.value.length !== 2) {
                return null;
            }
            if (filterItem.value[0] == null || filterItem.value[1] == null) {
                return null;
            }
            return (value) => {
                return (
                    value !== null &&
                    filterItem.value[0] <= value &&
                    value <= filterItem.value[1]
                );
            };
        },
        InputComponent: ScoreBetweenFilterComponent,
    };
